import length from "rfuncs/functions/length"
export default filename => {
    const folders = filename.split("/")
    const parts = folders.pop().split(".")
    const ext = length(parts) > 1 ? parts.pop() : ""

    return { basename: parts.join("."), ext, folder: folders.join("/") + "/" }
}
